import { Injectable } from "@angular/core";
import { Observable, catchError, retry } from "rxjs";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { RainMeters } from "../models/rainMeters";
import { Rainfall } from "../models/rainfall";
import { RainfallClassification } from "../models/rainfallClassification";

@Injectable({
    providedIn: 'root'
  })
  export class RainfallService extends BaseService {

    private API_RAINFALL_URL = this.API_BASE_URL + "rainfall"; 

    constructor(private httpClient: HttpClient,
        public _snackBar: MatSnackBar,
        public cookieService: CookieService,
        public translate: TranslateService) {
            super()
      }

    ////////////////////////////////////////////////////////////////////////////
    //////////////////                GET                     //////////////////
    ////////////////////////////////////////////////////////////////////////////

    getRainMeters(tenantId: number): Observable<RainMeters[]> {
        if(tenantId !== undefined && tenantId !== null){
        return this.httpClient.get<RainMeters[]>(this.API_RAINFALL_URL + "/findRainMetersForTenant?tenantId=" + tenantId)
            .pipe(
                retry(1),
                catchError(err => {
                    this._snackBar.open(this.translate.instant('DATA-SERVICE.RAIN-METERS'), this.translate.instant('SNACKBAR.DISMISS'), {
                        duration: 5000,
                    });
                    return this.errorHandler(err);
                })
            );
        }
    }

    getRainfall(rainMeterId: number): Observable<Rainfall[]> {
      return this.httpClient.get<Rainfall[]>(this.API_RAINFALL_URL + "/findRainfallForRainMeter?rainMeterId=" + rainMeterId)
        .pipe(
          retry(1),
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.RAINFALL'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    getRainfallClassifications(): Observable<RainfallClassification[]> {
      return this.httpClient.get<RainMeters[]>(this.API_RAINFALL_URL + "/findAllRainfallClassifications")
        .pipe(
          retry(1),
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.RAINFALL-CLASS'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             INSERT                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////

    insertRainfall(rainfall: Rainfall): Observable<any> {
      return this.httpClient.post<any>(this.API_RAINFALL_URL + "/createRainfall", rainfall)
        .pipe(
          catchError(err => {
            this.hasError.next(true);
            this._snackBar.open(this.translate.instant('DATA-SERVICE.INSERT-RAINFALL'), this.translate.instant('SNACKBAR.DISMISS'), {
              duration: 5000,
            });
            this.hasError.next(false);
            return this.errorHandler(err);
          })
        );
    }

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             UPDATE                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             DELETE                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////
    
  }  
